import { request } from "../utils/request.js"

export const saleOrder_exportForManage = (pojo, args) => request({
    url: 'saleOrder/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleOrder_getSumDataForManage = (pojo, args) => request({
    url: 'saleOrder/getSumDataForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: false,
    ...args
})

export const saleOrder_findPageForManage = (pojo, args) => request({
    url: 'saleOrder/findPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleOrder_findPageListForManage = (pojo, args) => request({
    url: 'saleOrder/findPageListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleOrder_findPageForCurrentUser = (pojo, args) => request({
    url: 'saleOrder/findPageForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleOrder_findPageListForCurrentUser = (pojo, args) => request({
    url: 'saleOrder/findPageListForCurrentUser',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleOrder_findPageForSelect = (pojo, args) => request({
    url: 'saleOrder/findPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleOrder_findPageListForSelect = (pojo, args) => request({
    url: 'saleOrder/findPageListForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleOrder_saveIntoDraft = (pojo, args) => request({
    url: 'saleOrder/saveIntoDraft',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleOrder_saveIntoDraftAndSubmit = (pojo, args) => request({
    url: 'saleOrder/saveIntoDraftAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleOrder_update = (pojo, args) => request({
    url: 'saleOrder/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleOrder_updateAndSubmit = (pojo, args) => request({
    url: 'saleOrder/updateAndSubmit',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleOrder_submitById = (id, args) => request({
    url: 'saleOrder/submitById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleOrder_deleteById = (id, args) => request({
    url: 'saleOrder/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleOrder_approval = (pojo, args) => request({
    url: 'saleOrder/approval',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const saleOrder_findById = (id, args) => request({
    url: 'saleOrder/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const saleOrder_findHeadVoById = (id, args) => request({
    url: 'saleOrder/findHeadVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

// findByIdIn - 
export const saleOrder_findByIdIn = (params, args) => request({
    url: 'saleOrder/findByIdIn',
    method: 'POST',
    params: params,
    showFailMessage: true,
    ...args
})

export const saleOrder_findVoById = (id, args) => request({
    url: 'saleOrder/findVoById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const saleOrder_generatePrintPdf = (pojo, args) => request({
    url: 'saleOrder/generatePrintPdf',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const saleOrder_updateOtherCost = (pojo, args) => request({
    url: 'saleOrder/updateOtherCost',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})


export const saleOrder_getLastBuyingPrice = (pojo, args) => request({
    url: 'saleOrder/getLastBuyingPrice',
    method: 'POST',
    params: pojo,
    showFailMessage: false,
    showSuccessMessage: false,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/saleOrder.js